module.exports = __webpack_public_path__ + "img/blue-invitation-icon.35cdbae7.svg";